import { AvailabilityStates } from '@coolblue-development/next-availability-state';
import { Product } from '@features/product/components/Collection/Collection.types';

export default function getFirstAvailableCollectionProduct(
  products: (Product | null)[] | undefined
): Product | null | undefined {
  return (
    products &&
    products.find(
      product =>
        product !== null &&
        product !== undefined &&
        product.urls !== null &&
        product.mediaGallery !== null &&
        product.nullableAvailabilityState &&
        product?.nullableAvailabilityState !== AvailabilityStates.OutOfStock &&
        product?.nullableAvailabilityState !== AvailabilityStates.TemporaryOutOfStock
    )
  );
}
